import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EAppointmentTypeModality;
(function (EAppointmentTypeModality) {
  EAppointmentTypeModality["OfficeVisit"] = "office-visit";
  EAppointmentTypeModality["Telehealth"] = "telehealth";
})(EAppointmentTypeModality || (EAppointmentTypeModality = {}));
export let EAppointmentTypeCriteria;
(function (EAppointmentTypeCriteria) {
  EAppointmentTypeCriteria["Id"] = "_id";
  EAppointmentTypeCriteria["Postcode"] = "postcode";
})(EAppointmentTypeCriteria || (EAppointmentTypeCriteria = {}));
export const fieldsAppointmentType = _extends({}, fieldsIBaseModel, {
  alternativeName: {
    type: 'Text'
  },
  checklist: {
    type: 'Object',
    array: true
  },
  daysAheadsToVerifyInsurance: {
    type: 'Number'
  },
  dependents: {
    type: 'Object',
    array: true
  },
  description: {
    type: 'Text'
  },
  duration: {
    type: 'Number'
  },
  externalId: {
    type: 'Object'
  },
  externalRawSource: {
    type: 'Unknown'
  },
  modality: {
    type: 'Option',
    values: EAppointmentTypeModality
  },
  name: {
    type: 'Text'
  },
  setting: {
    type: 'Text'
  },
  settings: {
    type: 'Object',
    array: true
  },
  specialInstructions: {
    type: 'Text',
    deprecated: true
  },
  specialInstructionsTemplates: {
    type: 'Object'
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  visible: {
    type: 'Boolean'
  }
});